module.exports = __webpack_public_path__ + "static/assets/dc23cc3ed481e388585dc7581f4d550f.png";